/**
 * silverliningEBilling模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const silverliningEBilling = {
  // 本份预测本份账单
  billThisMonthAndBillLastMonth(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/billThisMonthAndBillLastMonth`,params);
  },
  // 每月账单金额
  monthlyBillAmount(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/monthlyBillAmount`,params);
  },
  // 账单概览
  overviewBill(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/overviewBill`,params);
  },
  // 标签下拉框
  tagBox(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/tagBox`,params);
  },
  // Top 5 Billing by Tag&Top 3 Variance
  toCompare(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/toCompare`,params);
  },
  // Top 15资源类别
  to15ResourceCategories(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/to15ResourceCategories`,params);
  },
  // 标签两月对比
  tagTwoMonthVariance(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/tagTwoMonthVariance`,params);
  },
  // 标签两月对比 详情
  tagTwoMonthVarianceDetails(params) {
    return $http.post(`${global.API_URL}/sme/silverliningEBilling/tagTwoMonthVarianceDetails`,params);
  }
}

export default silverliningEBilling;



// WEBPACK FOOTER //
// ./src/api/silverliningEBilling.js